var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForestAcres({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "33px",
    viewBox: "0 0 37 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/forest-acres") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Impact",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Impact-Section",
    transform: "translate(-791.000000, -846.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Content",
    transform: "translate(267.500000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wide-Card",
    transform: "translate(0.000000, 605.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Large-Statistic",
    transform: "translate(523.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/forest-acres",
    transform: "translate(1.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFEDEB",
    points: "17.9999648 3.63043822 24.8955686 19.2032906 22.0481288 19.2032906 24.8930373 25.6043875 11.1068221 25.6043875 13.9517306 19.2032906 11.1042908 19.2032906"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9FD4CD",
    points: "3.28323577 25.6043875 5.17984145 21.3369896 3.28021234 21.3369896 8.46736627 9.61169998 10.7364165 14.7644009 7.82611753 21.3369896 10.6684948 21.3369896 8.77181881 25.6043875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#50BAB5",
    points: "25.3314349 21.3369896 28.1738825 21.3369896 25.2635835 14.7644712 27.5326337 9.61169998 32.7197173 21.3369896 30.8200179 21.3369896 32.7166939 25.6043875 27.2281109 25.6043875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5973738,27.7380864 L36,27.7380864 L34.103324,23.4706885 L35.9968359,23.4706885 L28.2567807,5.97437114 L26.8030023,5.97437114 L24.0947108,12.1245935 L18.72594,0 L17.27406,0 L11.9052892,12.1245232 L9.19699766,5.97437114 L7.74321925,5.97437114 L0.00309374396,23.4706885 L1.89667598,23.4706885 L0,27.7380864 L7.40262617,27.7380864 L7.40262617,30.582995 L1.64165304,30.582995 L1.64165304,32.7166939 L34.358347,32.7166939 L34.358347,30.582995 L28.5973738,30.582995 L28.5973738,27.7380864 Z M17.9999648,3.63043822 L24.8955686,19.2032906 L22.0481288,19.2032906 L24.8930373,25.6043875 L11.1068221,25.6043875 L13.9517306,19.2032906 L11.1042908,19.2032906 L17.9999648,3.63043822 Z M3.28323577,25.6043875 L5.17984145,21.3369896 L3.28021234,21.3369896 L8.46736627,9.61169998 L10.7364165,14.7644009 L7.82611753,21.3369896 L10.6684948,21.3369896 L8.77181881,25.6043875 L3.28323577,25.6043875 Z M16.9331154,30.582995 L9.53632512,30.582995 L9.53632512,27.7380864 L16.9331154,27.7380864 L16.9331154,30.582995 Z M26.4636749,30.582995 L19.0668143,30.582995 L19.0668143,27.7380864 L26.4636749,27.7380864 L26.4636749,30.582995 L26.4636749,30.582995 Z M25.3314349,21.3369896 L28.1738825,21.3369896 L25.2635835,14.7644712 L27.5326337,9.61169998 L32.7197173,21.3369896 L30.8200179,21.3369896 L32.7166939,25.6043875 L27.2281109,25.6043875 L25.3314349,21.3369896 Z",
    id: "Shape",
    fill: "#1A2C3B"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestAcres);
export default __webpack_public_path__ + "static/media/forest-acres.fe8e50f75109b9a04d5429e59e7df19e.svg";
export { ForwardRef as ReactComponent };